import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { setVehicleMileageTotal } from '../store/tripInformation.actions'
import { TripInformationConstants } from '../store/tripInformation.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setCalculateVehicleMileageTotal() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const tripInformation = pcrDoc.patient?.tripInformation
      if (tripInformation && Object.keys(tripInformation).length !== 0) {
        if (tripInformation.vehicleMileageEnd !== '' && tripInformation.vehicleMileageStart !== '') {
          const total = parseFloat(tripInformation.vehicleMileageEnd) - parseFloat(tripInformation.vehicleMileageStart)
          yield put(setVehicleMileageTotal(total.toFixed(2)))
        }
      }
    } catch (e) {
      yield put(throwPcrException(`setCalculateVehicleMileageTotal() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}
export function* setCalculateVehicleMileageTotalSaga() {
  yield takeLatest(
    [TripInformationConstants.CALCULATE_VEHICLE_MILEAGE_TOTAL],
    performWithMutexHOG,
    setCalculateVehicleMileageTotal
  )
}
